import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LinkAccount } from '@/pages/auth/link-account/LinkAccount';
import { SOCIAL_PROVIDERS } from '@/pages/auth/social/outcome';

// Reached from the Connected accounts card on a tenant host (`social/socialOrigin.ts`): the
// provider to connect, and the workspace page to go back to once it is attached. The provider set
// is derived, so a new provider is linkable here the moment it is named.
const searchSchema = z.object({
	provider: z.enum(SOCIAL_PROVIDERS),
	return: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/link-account')({
	validateSearch: searchSchema,
	component: LinkAccount,
});
